import React from "react";
import {
  chakra,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";

import { FaCircleNotch } from "react-icons/fa";

import styles from "./Styles.module.css";
import Header from "components/Header";
import Footer from "components/Footer";

export default function Command() {
  let language = localStorage.getItem("language");
  const newLanguage = require(`language/${language!}.json`);

  return (
    <>
      <Header />
      <chakra.div className={styles.container}>
        <chakra.h1>{newLanguage.commands.title}</chakra.h1>

        <Accordion allowToggle>
          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.moderation.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.moderation.commands.map(
                  (element: any) => (
                    <chakra.li>
                      <FaCircleNotch />
                      <chakra.p>t!{element.name}</chakra.p>
                      <chakra.span>{element.description}</chakra.span>
                    </chakra.li>
                  )
                )}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.configuration.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.configuration.commands.map((element: any) => (
                  <chakra.li>
                    <FaCircleNotch />
                    <chakra.p>t!{element.name}</chakra.p>
                    <chakra.span>{element.description}</chakra.span>
                  </chakra.li>
                ))}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.nsfw.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.nsfw.commands.map((element: any) => (
                  <chakra.li>
                    <FaCircleNotch />
                    <chakra.p>t!{element.name}</chakra.p>
                    <chakra.span>{element.description}</chakra.span>
                  </chakra.li>
                ))}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.multiporpose.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.multiporpose.commands.map((element: any) => (
                  <chakra.li>
                    <FaCircleNotch />
                    <chakra.p>t!{element.name}</chakra.p>
                    <chakra.span>{element.description}</chakra.span>
                  </chakra.li>
                ))}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.animal.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.animal.commands.map((element: any) => (
                  <chakra.li>
                    <FaCircleNotch />
                    <chakra.p>t!{element.name}</chakra.p>
                    <chakra.span>{element.description}</chakra.span>
                  </chakra.li>
                ))}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>

          <AccordionItem
            borderRadius="30px"
            border="2px solid #0A4E52"
            marginBottom="10px"
          >
            <AccordionButton>
              <Box flex="1" textAlign="left" fontSize="15pt" fontWeight="600">
                {newLanguage.commands.help.title}
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel pb={4}>
              <chakra.ul className={styles.list}>
                {newLanguage.commands.help.commands.map((element: any) => (
                  <chakra.li>
                    <FaCircleNotch />
                    <chakra.p>t!{element.name}</chakra.p>
                    <chakra.span>{element.description}</chakra.span>
                  </chakra.li>
                ))}
              </chakra.ul>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </chakra.div>
      <Footer />
    </>
  );
}
